import { parse, format } from "date-fns";

export function fromBackendDate(dateString?: string) {
  if (!dateString) {
    return "---";
  }
  const parsed = parse(dateString, "dd/MM/yyyy HH:mm", new Date());
  return format(parsed, "dd/MM/yyyy");
}
